import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {


    /**
     *Creates an instance of StorageService.
     * @memberof StorageService
     */
    constructor() {
    }

    /**
     *
     * @description get data from local storage based on the key
     * @param {string} key
     * @returns
     * @memberof StorageService
     */
    public getData(key: string) {
        return localStorage.getItem(key);
    }

    /**
     *
     * @description set data to localstorage by key and data
     * @param {*} data
     * @param {string} key
     * @memberof StorageService
     */
    public setData(key: string, data: any): void {
        localStorage.setItem(key, data);
    }
    public setUserData(key: string, data: any): void {
        sessionStorage.setItem(key, data);
    }

    /**
     *
     * @description remove item from local storage
     * @param {string} key
     * @memberof StorageService
     */
    public removeData(key: string) {
        localStorage.removeItem(key);
    }

    /**
     *@description clear complete storage
     *
     * @memberof StorageService
     */
    public clear() {
        localStorage.clear();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/services/storage-service.service.ts